import React, { useEffect, useState } from 'react';
import api from '../api';
import StandaloneBranchSetup from './StandaloneBranchSetup';
import BranchList from './BranchList';

const BranchesPage = ({ user }) => {
  const isManager = user.role === 'Manager' || user.role === 'Admin';
  const [showForm, setShowForm] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const res = await api.get('/companies');
        setCompanies(res.data);
        if (res.data.length) {
          setSelectedCompanyId(res.data[0].id);
          setSelectedCompany(res.data[0]);
        }
      } catch (err) {
        console.error('Error fetching companies for branches page', err);
      }
    };
    fetchCompanies();
  }, []);

  // Fetch full company data when selection changes
  useEffect(() => {
    const fetchCompanyDetails = async () => {
      if (selectedCompanyId) {
        try {
          const res = await api.get(`/companies/${selectedCompanyId}`);
          setSelectedCompany(res.data);
        } catch (err) {
          console.error('Error fetching company details', err);
        }
      }
    };
    fetchCompanyDetails();
  }, [selectedCompanyId]);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Branches</h1>
      {isManager && (
        <button 
          onClick={() => setShowForm(!showForm)} 
          className="bg-blue-500 text-white px-4 py-2 rounded mb-4"
        >
          {showForm ? 'Close' : '+ Add Branch'}
        </button>
      )}

      {isManager && showForm && (
        <div className="mb-6">
          <div className="mb-4">
            <label className="block mb-1 font-medium">Select Company</label>
            <select
              value={selectedCompanyId || ''}
              onChange={(e) => setSelectedCompanyId(parseInt(e.target.value))}
              className="border p-2 rounded w-full md:w-1/2"
            >
              {companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          {selectedCompanyId && selectedCompany && (
            <StandaloneBranchSetup 
              company={selectedCompany} 
              companyId={selectedCompanyId} 
              onSuccess={() => setShowForm(false)} 
            />
          )}
        </div>
      )}

      {selectedCompanyId && !showForm && <BranchList companyId={selectedCompanyId} />}
    </div>
  );
};

export default BranchesPage; 